import { reducers } from 'stylist'
import { combineReducers } from 'redux'
import { reducer as session } from 'redux-simple-auth'

const { notifications } = reducers

export default combineReducers({
  notifications,
  session
})



// WEBPACK FOOTER //
// ./src/reducers/index.js